/**
 * Dutch (Nederlands) language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_NL_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'Mijn Profiel',
    'lvt.menu.tw_profile': 'TW Profiel',
    'lvt.menu.company_profile': 'Bedrijfsprofiel',
    'lvt.menu.my_notifications': 'Mijn meldingen',
    'lvt.menu.sign_out': 'Afmelden',

    // footer
    'lvt.footer.back_to_top': 'Terug naar boven',
    'lvt.footer.terms_of_use': 'Gebruiksvoorwaarden',
    'lvt.footer.privacy_policy': 'Privacybeleid',
    'lvt.footer.support_information': 'Support informatie',
    'lvt.footer.transwide_home': 'Transwide Home',
    'lvt.footer.license_nr': 'Licentienr.:',
    'lvt.footer.build_version': 'Build version:',

    // order list columns
    'lvt.order_list.header': 'Orderlijst',
    'lvt.order_list.column.shipperCompany': 'Verlader',
    'lvt.order_list.column.reference': 'Referentie',
    'lvt.order_list.column.status': 'Status',
    'lvt.order_list.column.statusReason': 'Reden status',
    'lvt.order_list.column.senderCompany': 'Verzender',
    'lvt.order_list.column.senderZipcode': 'Postcode verzender',
    'lvt.order_list.column.senderCity': 'Plaats verzender',
    'lvt.order_list.column.receiverCompany': 'Ontvanger',
    'lvt.order_list.column.receiverZipcode': 'Postcode ontvanger',
    'lvt.order_list.column.receiverCity': 'Plaats ontvanger',
    'lvt.order_list.column.carrierName': 'Transporteur',
    'lvt.order_list.column.plannedPickupEndDate': 'Geplande ophaling',
    'lvt.order_list.column.etaPickup': 'ETA bij ophaling',
    'lvt.order_list.column.delayAtPickup': 'Vertraging bij ophaling',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Geplande levering',
    'lvt.order_list.column.etaDelivery': 'ETA bij levering',
    'lvt.order_list.column.delayAtDelivery': 'Vertraging bij levering',
    'lvt.order_list.column.timestamps': 'Tijdstempels',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Gevraagd',
    'lvt.order_list.status.failed': 'Fout',
    'lvt.order_list.status.waiting': 'Wachten',
    'lvt.order_list.status.active': 'Actief',
    'lvt.order_list.status.stopped': 'Fout',
    'lvt.order_list.status.completed': 'Afgerond',
    'lvt.order_list.status.cancelled': 'Geannuleerd',
    'lvt.order_list.status.timeout': 'Gestopt',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Vervoerder niet toegewezen',
    'lvt.order_list.status_reason.plate_number_not_present': 'Nummerplaat niet aanwezig',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'Nummerplaat niet herkend',
    'lvt.order_list.status_reason.plate_number_not_operational': 'Nummerplaat niet operationeel',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Technical error when creating the tour in GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'rijen per pagina',
    'lvt.order_list.pagination.first': 'Eerst',
    'lvt.order_list.pagination.previous': 'Vorige',
    'lvt.order_list.pagination.next': 'Volgende',
    'lvt.order_list.pagination.last': 'Laatste',
    'lvt.order_list.pagination.no_orders_found': 'Geen orders gevonden',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Trailer',
    'lvt.map.tracked_device.tractor': 'Trekker',
    'lvt.map.tracked_device.mobile': 'gsm',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'Open orderlijst',
    'lvt.map.traffic_information.traffic': 'Traffic',
    'lvt.map.traffic_information.fast': 'Fast',
    'lvt.map.traffic_information.slow': 'Slow',
    'lvt.map.pickup_popup.pickup': 'Ophaling',
    'lvt.map.pickup_popup.date': 'Datum',
    'lvt.map.pickup_popup.address': 'Adres',
    'lvt.map.delivery_popup.delivery': 'Levering',
    'lvt.map.delivery_popup.date': 'Datum',
    'lvt.map.delivery_popup.address': 'Adres',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'In transit richting levering',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'In transit richting ophaling',
    'lvt.map.current_gps_popup.current_speed': 'Huidige snelheid',
    'lvt.map.current_gps_popup.average_speed': 'Gemiddelde snelheid',
    'lvt.map.current_gps_popup.last_location_update': 'Update laatste locatie',
    'lvt.map.current_gps_popup.eta': 'ETA',
    'lvt.map.current_gps_popup.planned_time': 'Geplande tijd',
    'lvt.map.current_gps_popup.arrival_delay': 'Vertraging aankomst',
    'lvt.map.current_gps_popup.speed_unit': 'km/u',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Aangekomen op vertrekpunt',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'Niet aangekomen op vertrekpunt',
    'lvt.order_list.timestamp.left_origin': 'Vertrekpunt verlaten',
    'lvt.order_list.timestamp.not_left_origin': 'Vertrekpunt niet verlaten',
    'lvt.order_list.timestamp.arrived_at_destination': 'Aangekomen op bestemming',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'Niet aangekomen op bestemming',
    'lvt.order_list.timestamp.left_destination': 'Bestemming verlaten',
    'lvt.order_list.timestamp.not_left_destination': 'Bestemming niet verlaten',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-nl.ts